import axiosInstance from '../utils/axios';

export interface LoginParams {
  username: string;
  password: string;
}

export interface UserInfo {
  id: number;
  username: string;
  name?: string;
  role?: string;
  // 根据实际接口返回添加其他字段
}

class AuthService {
  async login(params: LoginParams): Promise<{ token: string; user: UserInfo }> {
    try {
      const response = await axiosInstance.post('/users/login', params);
      const { token, user } = response.data;
      
      // 保存token到localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      
      return { token, user };
    } catch (error) {
      console.error('登录失败:', error);
      throw error;
    }
  }

  logout(): void {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  getUser(): UserInfo | null {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  }

  getCurrentUser(): UserInfo | null {
    return this.getUser();
  }

  isAuthenticated(): boolean {
    return !!this.getToken();
  }
}

export const authService = new AuthService(); 